<template>

  <auth-layout>
    <div class="py-9">
      <div class="mb-5">
        <label class="form-label">Adresse email</label>
        <input type="email" @keydown.enter="login" placeholder="email@domaine.com" v-model="email" class="form-input"/>
      </div>
      <div class="mb-5">
        <div class="flex items-center justify-between">
          <label class="form-label">Mot de passe</label>
          <a class="text-primary underline"  target="_blank" :href="forgotLink">Oublié ?</a>
        </div>
        <input type="password" @keydown.enter="login" v-model="password" class="form-input" placeholder="Entrez votre mot de passe"/>
      </div>
      <div v-if="error" class="text-red-600 font-medium">{{error}}</div>
      <div v-else-if="$route.query.error === 'not_merchant_account'" class="text-red-600 font-medium">Ce compte n'est pas celui d'un restaurant, vous ne pouvez pas vous connecter ici.</div>
      <div v-else-if="$route.query.error" class="text-red-600 font-medium">Vous n'avez pas les permissions nécessaire de vous connecter ici.</div>

      <div class="flex flex-col items-start gap-3 mt-8">
        <button class="btn-large bg-primary text-white w-full" @click="login">Connexion</button>
        <div class="w-full flex items-center justify-center gap-3 my-1">
          <div class="h-[1px] bg-neutral-300 flex-1"></div>
          <span class="text-neutral-700">ou</span>
          <div class="h-[1px] bg-neutral-300 flex-1"></div>
        </div>
        <button class="btn-large bg-primary text-white w-full" @click="$router.push({name:'login_text_message'})">Connexion rapide par SMS</button>
      </div>
    </div>
  </auth-layout>
</template>

<script>
import AuthLayout from "@/components/Layouts/AuthLayout.vue";
import {mapActions} from "vuex";
import {getCurrentAccount} from "@/services/AccountService";
export default {
  components: {AuthLayout},
  data(){
    return {
      email: null,
      password: null,
      error: false,
    }
  },
  computed: {
    forgotLink(){
      return 'https://auth.delicity.com/forgot-password?email='+ encodeURIComponent(this.email);
    }
  },
  methods: {
    async tokenLogin(token){
      this.$store.dispatch('loginTokenAction', {token})
          .then(async () => {
            await getCurrentAccount()
                .then((data) => {
                  this.$store.commit('account/SET_ACCOUNT', data);
                  this.$store.dispatch('getMerchantsAction');
                  this.$router.push({name: 'analytics'});
                })
                .catch((e) => {
                  localStorage.clear();
                  this.error = this.$t('errors.not_merchant_account')
                })
          })
    },

    async login(){
      this.$store.dispatch('loginAction', {username: this.email, password: this.password})
          .then(async () => {
            await getCurrentAccount()
                .then((data) => {
                  this.$store.commit('account/SET_ACCOUNT', data);
                  this.$store.dispatch('getMerchantsAction');
                  this.$router.push({name: 'analytics', query: {fromAuth: 'fromAuth'}});
                })
                .catch((e) => {
                  localStorage.clear();
                  this.error = this.$t('errors.not_merchant_account')
                })
          })
          .catch((e) => {
            if(e.response.data && e.response.data.message && this.$te('errors.'+e.response.data.message)){
              this.error = this.$t('errors.'+e.response.data.message)
            }
            else{
              this.error = this.$t('errors.unknown')
            }
          })
    },
  },
  mounted() {
    if(this.$route.query.email){
      this.email = this.$route.query.email;
    }
    if(this.$route.query.token){
      this.tokenLogin(this.$route.query.token);
    }
  }
}
</script>
